<script lang="ts">
import MainStore, { InteractionPointType } from "@src/model/Main.Store";

import { onDestroy, onMount } from "svelte";
import Choose from "./overlay/Choose.svelte";
import Info from "./overlay/Info.svelte";
import Prompt from "./overlay/Prompt.svelte";





let subscribeList: any[] = [];

let lastInteractionPoint: any = undefined;

onMount(() => {
    subscribeList.push(
        MainStore.getValue().currentExecutingInteractionPoint.subscribe((v) => {
            if (v === undefined) { lastInteractionPoint = undefined; }
            else {
                if (lastInteractionPoint && lastInteractionPoint === v) { return; }
                MainStore.getValue()._currentVideoElement?.pause();
                lastInteractionPoint = v;
            }
        })
    )
});

onDestroy(() => {
    subscribeList.forEach((v) => v());
});

</script>


{#if lastInteractionPoint}
<div id="main-overlay">
    {#if lastInteractionPoint.type === InteractionPointType.INFO}
    <Info text={lastInteractionPoint.text} />
    {:else if lastInteractionPoint.type === InteractionPointType.PROMPT}
    <Prompt text={lastInteractionPoint.text} target={lastInteractionPoint.target} />
    {:else if lastInteractionPoint.type === InteractionPointType.CHOOSE}
    <Choose text={lastInteractionPoint.text} choices={lastInteractionPoint.choices} />
    {:else}
    {JSON.stringify(lastInteractionPoint)}
    {/if}
</div>
{/if}


<style>
    #main-overlay {
        position: fixed;
        background-color: white;
        z-index: 1000;
        width: 100%;
        height: 100%;
    }
</style>
